export type TerminalLocationInfo = {
  airportCode: string;
  terminalName: string;
  terminalNumber: string | number;
};

export const formatTerminalsByNumber = (terminals: any[] = []) => {
  return terminals.reduce((acc, terminal) => {
    const {
      terminalNumber,
      airportCode,
      terminalName,
    } = terminal;

    if (terminalNumber != null && terminalNumber !== "") {
      acc[terminalNumber.toString()] = `${airportCode} - ${terminalName} - ${terminalNumber}`;
    }

    return acc;
  }, {} as Record<string, string>);
};

export const formatTerminalsByAirportCode = (terminals: any[] = []) => {
  return terminals.reduce((acc, terminal) => {
    const { airportCode, terminalName, terminalNumber } = terminal;

    const info: TerminalLocationInfo = {
      airportCode,
      terminalName,
      terminalNumber,
    };

    if (airportCode) {
      acc[airportCode.toUpperCase()] = info;
    }

    if (terminalName) {
      acc[terminalName.toUpperCase()] = info;
    }

    return acc;
  }, {} as Record<string, TerminalLocationInfo>);
};

export const parseTurnNumberAirportCodes = (turnNumber?: string) => {
  if (!turnNumber) return [];

  return turnNumber
    .split("-")
    .map((segment) => segment.trim())
    .filter(Boolean);
};

export const formatTerminalsByTurnSegments = (
  segmentMatches: Array<{ segment: string; terminal: any }> = []
) => {
  return segmentMatches.reduce((acc, match) => {
    const { airportCode, terminalName, terminalNumber } = match.terminal;

    acc[match.segment.toUpperCase()] = {
      airportCode,
      terminalName,
      terminalNumber,
    };

    return acc;
  }, {} as Record<string, TerminalLocationInfo>);
};

export const getAirportCodeForDrop = (
  dropType?: string,
  turnNumber?: string
): string | null => {
  if (!turnNumber) return null;

  const segments = turnNumber
    .split("-")
    .map((segment) => segment.trim())
    .filter(Boolean);

  if (segments.length === 0) return null;
  if (dropType === "O") return segments[0];
  if (dropType === "F") return segments[segments.length - 1];

  return null;
};
export const removeEmptyValues = <T extends Record<string, any>>(obj: T): Partial<T> =>
  Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) =>
        value !== "" &&
        value !== undefined &&
        value !== null
    )
  ) as Partial<T>;

export const getDisabledDayValues = (weekStartDate: string) => {
  const start = new Date(weekStartDate);
  const today = new Date();

  // Normalize time
  start.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  const diffInDays =
    Math.floor((today.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));

  return diffInDays >= 0 ? diffInDays + 1 : 0;
};
